export type MapPinIconProps = {
    strokeWidth?: number;
    strokeColor?: string;
};

const MapPinIcon = ({ strokeWidth = 1.005, strokeColor = 'currentColor' }: MapPinIconProps) => {
    return (
        <g transform="translate(1.75, 1.17)">
            {/* Main pin shape */}
            <path
                d="M5.25 0C2.35 0 0 2.35 0 5.25C0 9.19 5.25 11.67 5.25 11.67C5.25 11.67 10.5 9.19 10.5 5.25C10.5 2.35 8.15 0 5.25 0Z"
                fill="none"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
            {/* Center dot */}
            <circle cx="5.25" cy="5.25" r="2.04" fill="none" stroke={strokeColor} strokeWidth={strokeWidth} />
        </g>
    );
};

export default MapPinIcon;
